import React from "react";
import moment from "moment";
import Html from "../../components/utilities/Html";
import { getColor } from "../../util/CC";
import { getOGColor } from "../../util/Utils";
import { Space } from "antd";
import { useHistory } from "react-router-dom";

export default function EventUI(props) {

    const template = window.sitesettings.template_info;
    const history = useHistory();

    const {
        highlight_colour = 0,
        text_colour = 0,
        event = {},
        event_id = 0,
        title_preset = 0,
        date_preset = 0,
        description_preset = 0,
        link = false,
        link_id = 0,
    } = props;

    const {
        info = {},
        from = 0,
        to = 0,
        id = 0,
    } = event;

    const {
        name = "",
        description = ""
    } = info;

    const start = moment.unix(from).tz('America/Los_Angeles');

    const drawDateRange = (_start_ts, _end_ts) => {

        // lock to pacific time
        let start_time = moment.unix(_start_ts).tz('America/Los_Angeles');
        let end_time = moment.unix(_end_ts).tz('America/Los_Angeles');
        // format
        let format = 'dddd MMMM Do, YYYY @ h:mmA';
        // check if the range spans over multiple days
        if (start_time.isSame(end_time, 'day')) {
            // start and end match - just display start
            if (_start_ts === _end_ts) {
                return start_time.format(format);
            }
            // same day, draw one date and time range
            return start_time.format(format) + ' - ' + end_time.format('h:mmA');
        } else {
            // different days, draw the date and time for each day
            return start_time.format(format) + ' - ' + end_time.format(format);
        }
    }

    return (

        <>
            <Space size={20} align="start">
                {/* <div style={{ "width": "50px", "lineHeight": "20px", "marginTop": "5px", "padding": "4px 0px", "height": "70px", "overflow": "hidden", "textAlign": "center", "color": getColor(text_colour, template, "#000"), "backgroundColor": getColor(highlight_colour, template, "#fff") }}>
                    <div><small>{start.format("MMM").toUpperCase()}</small></div>
                    <div style={{ "fontSize": "20px" }}>{start.format("D")}</div>
                    <div><small>{start.format("YYYY")}</small></div>
                </div> */}

                <div>
                    <h4 onClick={() => {
                        if (link) {
                            history.push("/events/" + id)
                        }
                    }} style={{ "display": "block", "cursor": (link) ? "pointer" : "default" }} >
                        <span className={(link) ? "bm-txt-" + title_preset + " underline" : "bm-txt-" + title_preset}>{name}</span>
                    </h4>
                    <div className="shim" />
                    <div style={{ "display": "block" }} className={"bm-txt-" + date_preset}>
                        {drawDateRange(from, to)}
                    </div>
                    <div className="shim" /><div className="shim" />
                    <div style={{ "display": "block" }} className={"bm-txt-" + description_preset}>
                        <Html className={"bm-lnkin-" + link_id} html={description} />
                    </div>
                </div>
            </Space>
        </>

    )
}